import { Card, CardContent } from "@/components/ui/card";
import { formatCurrency, formatCurrencyRounded } from "@/lib/utils";

interface Props {
  totalInputCost: number;
  costPerUnit: number;
  sellingPrice: number;
  grossMarginPercent: number | null;
}

export function ProductionCostSummary({
  totalInputCost,
  costPerUnit,
  sellingPrice,
  grossMarginPercent,
}: Props) {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
      <Card className="bg-muted/30 shadow-none">
        <CardContent className="p-3">
          <div className="text-xs text-muted-foreground">Total Biaya Bahan</div>
          <div className="mt-1 font-mono text-lg font-bold">
            {formatCurrencyRounded(totalInputCost)}
          </div>
        </CardContent>
      </Card>

      <Card className="bg-primary/5 border-primary/20 shadow-none">
        <CardContent className="p-3">
          <div className="text-xs font-medium text-primary">
            HPP per Cup / Porsi
          </div>
          <div className="mt-1 font-mono text-lg font-bold text-primary">
            {formatCurrency(costPerUnit)}
          </div>
        </CardContent>
      </Card>

      <Card className="bg-muted/30 shadow-none">
        <CardContent className="p-3">
          <div className="text-xs text-muted-foreground">
            Margin Kotor Proyeksi
          </div>
          <div className="mt-1 flex items-baseline gap-2 font-mono text-lg font-bold">
            {grossMarginPercent != null ? (
              <span
                className={
                  grossMarginPercent >= 50
                    ? "text-emerald-600 dark:text-emerald-400"
                    : "text-amber-600"
                }
              >
                {grossMarginPercent}%
              </span>
            ) : (
              <span className="text-muted-foreground text-sm font-normal">
                -
              </span>
            )}
            {sellingPrice > 0 && (
              <span className="text-xs font-normal text-muted-foreground">
                (Jual: {formatCurrency(sellingPrice)})
              </span>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
